// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__2SamL","left":"StickyBox_left__2AtfV","right":"StickyBox_right__F9hZU"};